import { Injectable } from '@angular/core';
import { DataBusService } from 'src/api/services/data-bus.service';
import { BehaviorSubject, Observable } from "rxjs";
import { DataBusLicense } from 'src/api/models/data-bus-license';
import { LicenseService } from 'src/api/services';

@Injectable()
export class DataBusTableService {
  public remoteData: Observable<DataBusLicense[]>;
  private _remoteData: BehaviorSubject<DataBusLicense[]>;
  public data: DataBusLicense[];

  constructor(private readonly service: DataBusService) {
    this._remoteData = new BehaviorSubject([]);
    this.remoteData = this._remoteData.asObservable();
    //this.remoteData = service.DataBusGetCustomerLicenses();
  }

  get(customerId: number) {
    //this.remoteData.
    if (customerId == null){
      this.service.DataBusGetCustomerLicenses().subscribe(results => {
        //console.log(results);
        this._remoteData.next(results);
        this.data = results;
      });
    } else {
      this.service.DataBusGetLicensesForCustomer(customerId).subscribe(results => {
        //console.log(results);
        this._remoteData.next(results);
        this.data = results;
      });
    }
  }

  update(license: DataBusLicense) : Observable<DataBusLicense> {
    return this.service.DataBusUpdateLicense(license);
  }
}
